export const versionLog = [
  {
    version: "3.7.5",
    date: "2026-10-15",
    changes: [
      "Penambahan pelaporan lupa Absen masuk di H + 0",
      "Penambahan nama koordinator di Pilihan karyawan menu Piket dan Lembur"

    ],
  },
  {
    version: "3.7.4",
    date: "2026-10-03",
    changes: [
      "Penambahan Kebijakan Privasi aplikasi (Privacy Policy)",
      "Persetujuan awal (Consent) sebelum validasi NIK & akses perangkat",
      "Klausul transparansi monitoring lokasi pasca absen masuk (30 menit / 1 jam)",
    ],
  },
  {
    version: "3.7.3",
    date: "2026-09-30",
    changes: [
      "Perbaikan Data dropdown lokasi",
      "Perbaikan Menu Pengajuan Piket",
      "Perbaikan Card urutan antrian penanganan IT",
      "Validasi dan penanganan akun karyawan berstatus resign",
    ],
  },
  {
    version: "3.7.2",
    date: "2026-09-26",
    changes: [
      "Penambahan nama karyawan di laporan lupa absen",
      "Penambahan petunjuk NIK & Kode. Debitur",
    ],
  },
  {
    version: "3.7.1",
    date: "2026-09-25",
    changes: [
      "Perbaikan bug tampilan Riwayat Pengajuan",
      "Persiapan UI untuk implementasi di Agen",
    ],
  },
  {
    version: "3.7.0",
    date: "2026-09-17",
    changes: [
      "Integrasi data Agen",
      "Bebas validasi Device ID untuk akun Agen",
      "Pembatasan akses menu pemesanan ATK berdasarkan profil gender",
      "Perbaikan bug riwayat pengajuan",
      "Penyempurnaan tampilan UI",
    ],
  },
  {
    version: "3.6.2",
    date: "2026-09-05",
    changes: [
      "Pembaruan Layout Aplikasi",
      "Perbaikan Pengajuan Lembur",
      "Perbaikan penyimpanan Localstorage",
    ],
  },
  {
    version: "3.6.1",
    date: "2026-08-20",
    changes: [
      "Perbaikan pilihan lokasi di menu Asset, Request IT & ATK",
      "Perbaikan UX di menu Request IT & ATK",
      "Perbaikan metadata APlikasi",
      "Penambahan label Arah di menu Keluar masuk kendaraan",
      "Penambahan Penginputan Surat jalan di menu Lengkapi Keluar masuk kendaraan",
    ],
  },
  {
    version: "3.6.0",
    date: "2026-08-28",
    changes: [
      "Penambahan menu Request IT",
      "Penambahan menu Request Pemesanan ATK",
      "Penambahan Input Data STNK di Checklist kendaraan",
      "Penambahan Input Tonase dan Quantity di Keluar masuk kendaraan",
      "Perbaikan bug ttd aproval Pengganti",
    ],
  },
  {
    version: "3.5.1",
    date: "2026-08-10",
    changes: [
      "Perbaikan bug gambar tidak tampil di menu Keluar masuk kendaraan",
      "Perbaikan bug gambar tidak tampil di menu Patroli",
      "Perbaikan bug gambar tidak tampil di menu Checklist Kendaraan",
      "Perubahan tampilan riwayat pencatatan Keluar masuk kendaraan",
      "Perubahan tampilan riwayat pencatatan Patroli",
    ],
  },
  {
    version: "3.5.0",
    date: "2026-08-10",
    changes: [
      "Penambahan menu Security untuk jabatan Security",
      "Penambahan menu Monitoring Pengisian BBM, untuk yang di tugaskan",
      "Penambahan menu Monitoring Checklist Kendaraan, untuk yang di tugaskan",
      "Penyelesaian bug absen penanda hari libur",
      "Penyesuaian radius validasi absen masuk.",
    ],
  },
  {
    version: "3.4.9",
    date: "2026-07-27",
    changes: [
      "Penyelesaian bug badge di menu notifikasi",
      "Penambahan label di menu absen bagian riwayat absen ",
      "Pengoptimalan performa di menu Handover",
      "Penjelasan jenis izin di menu izin tab Izin / Cuti dan Sakit",
      "Penyesuaian radius validasi absen masuk.",
    ],
  },
  {
    version: "3.4.8",
    date: "2026-07-15",
    changes: [
      "Perubahan Prosedur Lupa Absen, revisi 2.",
      "Penyesuaian radius validasi absen masuk dan pulang.",
    ],
  },
  {
    version: "3.4.7",
    date: "2026-07-14",
    changes: [
      "Penghapusan validasi lokasi 1 jam setelah absen masuk untuk divisi Pickup & Outbound Sidareja.",
      "Penyesuaian validasi lokasi 30 menit setelah absen masuk untuk divisi Delivery.",
    ],
  },
  {
    version: "3.4.6",
    date: "2026-07-13",
    changes: [
      "Perubahan Prosedur Lupa Absen, revisi 1.",
      "Uji Coba validasi lokasi 1 jam setelah absen masuk.",
    ],
  },
  {
    version: "3.4.5",
    date: "2026-07-09",
    changes: [
      "Menghilangkan rekapan uang makan untuk Freelance.",
    ],
  },
  {
    version: "3.4.4",
    date: "2026-07-09",
    changes: [
      "Penyelesaian bug absen shift jam 13:00 pulang dini hari.",
      "Penyelesaiain bug shift security jam 19:00 dan jam 07:00, absen masuk harus setelah masuk jam tersebut.",
      "Penambahan version dan update perubahan.",
    ],
  }
];

export const currentVersion = versionLog[0].version;
